import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type UpdateMerchantLimitRequest = {
    merchantId: number;
    merchantLimitId: number;
    newLimit: number;
    [key: string]: string | number | boolean | undefined;
}

async function updateMerchantLimit(data: UpdateMerchantLimitRequest): Promise<BaseResponse<any>> {
    try {
        return (await axiosInstance.post("/MerchantLimits/UpdateLimitForMerchant", data))
            .data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useUpdateMerchantLimit() {
    return useMutation<BaseResponse<any>, Error, UpdateMerchantLimitRequest>((variables) =>
        updateMerchantLimit(variables)
    );
}